/*
 * Basic Javascript helpers used in analytics.js and graphics code.
 */

module.exports = {
  classify: require("./classify"),
  COLORS: require("./colors"),
  fmtComma: require("./fmtComma"),
  formatDate: require("./formatDate"),
  formatStyle: require("./formatStyle"),
  getAPMonth: require("./getAPMonth"),
  getLocation: require("./getLocation"),
  getParameterByName: require("./getParameterByName"),
  isProduction: require("./isProduction"),
  makeTranslate: require("./makeTranslate"),
  urlToLocation: require("./urlToLocation"),
  wrapText: require("./wrapText")
};
